import React from 'react';

import { Group, Stack } from '../../../../Layout';
import { Text } from '../../../../Typography';
import classes from './SectionedInfo.module.css';

type SectionedInfoCardProps = {
  children: React.ReactNode;
  size?: 'sm' | 'md';
  withCard?: boolean;
};

const SectionedInfo = ({ children, size = 'sm', withCard = false }: SectionedInfoCardProps) => {
  return (
    <Group
      className={classes.SectionedInfo}
      mod={{
        size,
        card: withCard,
      }}
    >
      {children}
    </Group>
  );
};

type SectionedInfoItemProps = {
  label: string;
  children: string | string[];
  size?: 'sm' | 'md';
};

/**
 * If using this without <SectionedInfo.Card>, make sure to wrap these in a flex container where `align-items` is `normal`.
 */
const SectionedInfoItem = ({ label, children, size = 'sm' }: SectionedInfoItemProps) => {
  return (
    <Stack className={classes.SectionedInfoItem} mod={{ size }}>
      {!!label && <Text className={classes.SectionedInfoItem__label}>{label}</Text>}
      <Text className={classes.SectionedInfoItem__value}>{children}</Text>
    </Stack>
  );
};

SectionedInfo.Item = SectionedInfoItem;

export { SectionedInfo, SectionedInfoItem };
